export default __webpack_public_path__ + "static/media/Doribac-100-ml-eng.3f81894f.jpg";